import React from "react";
import { makeStyles } from "tss-react/mui";
import { keyframes } from "tss-react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";

const useStyles = makeStyles()(() => ({
  snowingBackdrop: {
    position: "absolute",
    top: 0,
    bottom: 0,
    overflow: "hidden",
    background: "-webkit-radial-gradient(bottom, ellipse cover,  rgb(9,76,114) 0%,rgb(1,41,63) 100%)",
  },
  snowflake: {
    display: "inline-block",
    width: "0.1%",
    color: "#FFFAFA",
    opacity: 0,
    fontSize: "120px",
    margin: 0,
    padding: 0,
    animation: `${keyframes`
        0% {
            opacity: 0;
        }
        3% {
            opacity: 0.9;
        }
    
        90% {
            opacity: 0.9;
        }
        100% {
            transform: translate(0, 97vh);
            opacity: 0;
        `} 16s linear infinite`,
  },
}));

const Snowing: React.FC<{}> = React.memo(() => {
  const { classes } = useStyles();
  let snowflakes: JSX.Element[] = [];
  for (let snowFlakeCount = 0; snowFlakeCount < 1000; snowFlakeCount++) {
    const animationDelay = `${(Math.random() * 16).toFixed(2)}s`;
    const fontSize = `${Math.floor(Math.random() * 20) + 10}px`;
    snowflakes.push(
      <Typography
        style={{
          animationDelay,
          fontSize,
        }}
        className={classes.snowflake}
        key={snowFlakeCount}
      >
        *
      </Typography>
    );
  }

  return <Box className={classes.snowingBackdrop}>{snowflakes}</Box>;
});

export default Snowing;
